<script setup>
import { useLoader } from '@/composables/useLoader';
const { isLoading } = useLoader();
</script>

<template>
  <Transition name="fade">
    <div v-if="isLoading" class="preloader">
      <div class="preloader__logo">
        <svg
          class="preloader__logo-svg"
          width="55"
          height="73"
          viewBox="0 0 55 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.4526 48.947C13.8285 49.2596 14.4759 49.7355 14.629 49.8429L27.4188 58.944L27.5023 59L27.5812 58.944L40.371 49.8452C40.5032 49.7519 41.1552 49.2759 41.5474 48.9493C41.6495 48.863 41.8792 48.6343 41.9651 48.5317C44 46.0797 44 43.539 44 41.6842V7.61968L36.2872 0V39.2719C36.2872 40.7184 35.6653 42.0949 34.584 43.0491L27.5 49.2829L20.416 43.0491C19.3324 42.0949 18.7128 40.7184 18.7128 39.2719V0L11 7.61968V41.6819C11 43.5367 11 46.0773 13.0349 48.5294C13.1185 48.6297 13.3482 48.8607 13.4526 48.947Z"
            fill="white"
          />
          <path
            d="M27.4571 72.9738L27.5001 73L27.543 72.9738C27.7364 72.8549 46.9999 60.9461 51.6815 54.9286C55.155 50.4643 55.0524 45.7193 54.976 42.254C54.9664 41.7735 54.9545 41.3169 54.9545 40.8864V17.768L47.019 10V42.2397C47.019 44.1448 47.019 47.3319 44.6889 50.3977C44.5314 50.607 43.5168 51.6202 43.0393 51.9913C42.557 52.3647 42.1273 52.6858 42.0843 52.7143L27.5001 62.9963L12.9158 52.7143C12.8728 52.6834 12.4383 52.3623 11.9609 51.9913C11.4834 51.6202 10.4712 50.6046 10.3112 50.3977C7.98116 47.3319 7.98116 44.1424 7.98116 42.2397V10.0024L0.0456317 17.7703V40.8887C0.0456317 41.3169 0.0360864 41.7735 0.0241497 42.2563C-0.0522453 45.7217 -0.157291 50.4667 3.31868 54.931C8.00026 60.9461 27.2637 72.8525 27.4571 72.9738Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.preloader {
  position: fixed;
  inset: 0;
  background-color: $old-surface-2;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  transform-origin: center top;

  &__logo {
    &-svg {
      animation: preloaderFade 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }
  }
}

@keyframes preloaderFade {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  50% {
    opacity: 1;
    visibility: visible;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
</style>
